"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertObject;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function assertObject(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  if (_typeof(value) !== 'object' || Array.isArray(value)) {
    throw new TypeError("".concat(label, " needs to be a plain object"));
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/utils/assertObject.js
// module id = 908
// module chunks = 0